
const createAccountManagementOverrides = (accountIds, selectedAccountIds) => {
  if (!selectedAccountIds?.length) return []
  const hiddenValues = [...new Set(accountIds.filter((accountId) => !selectedAccountIds.flat().includes(accountId)))]

  return hiddenValues.map(id => ({
    id,
    isIncluded: false
  }))
}

export const getFilterValue = (filterLevel, groupIds, selectedIds) => {
  switch (filterLevel) {
    case 'account': {
      return createAccountManagementOverrides(groupIds, selectedIds)
    }
    default:
      return []
  }
}
